// extracted by mini-css-extract-plugin
module.exports = {"button":"Switch_button__3mlmS","outer":"Switch_outer__-SAWj","largeSize":"Switch_largeSize__2WVtm","inner":"Switch_inner__2Q7YA","on":"Switch_on__3rcfl"};